import fileSys from "../fileoprators/fileSystem";
import SettingsOprator from "./settingsoprator";
const DEFAULTSET = {
  domestic: {
    ip: "47.98.209.109",
    port: "8088",
    path: "dea520update/Mediworks"
  },
  foreign: {
    ip: "47.98.209.109",
    port: "8088",
    path: "dea520update/Mediworks"
  },
  isUpdateTipVisible: true
};
class Update extends SettingsOprator {
  constructor() {
    super(fileSys.getCfgPath("update.json"), DEFAULTSET);
  }
  getUpdateSettings() {
    return this.getSettings();
  }
  saveUpdateSettings(settings) {
    this.saveSettings(settings);
  }
}
export default Update;



// WEBPACK FOOTER //
// ./src/settings/update.js